import { Claim, TenantCapabilities } from '../@types/organization';
import {
  INTERNAL_PERMISSION_CLAIMS,
  isPermissionClaimAvailable,
  PermissionClaims
} from 'access/claims';

export const USER_ACCESS_TEMPLATE_ROLES = {
  admin: 'CompanyAdmin',
  campaignManager: 'CompanyUser'
} as const;

export const getAdminTemplateClaims = (capabilities: TenantCapabilities): Claim[] =>
  Object.values(PermissionClaims)
    .filter(
      (claimValue) =>
        claimValue !== PermissionClaims.TenantClaimsAssign &&
        !INTERNAL_PERMISSION_CLAIMS.has(claimValue) &&
        isPermissionClaimAvailable(claimValue, capabilities)
    )
    .map((claimValue) => ({ claimType: 'permissions', claimValue }));

export const CAMPAIGN_MANAGER_TEMPLATE_CLAIMS: Claim[] = [
  { claimType: 'permissions', claimValue: PermissionClaims.ResponseUpdate }
];

export const getClaimsByTemplateRole = (
  templateRole: string,
  capabilities: TenantCapabilities
): Claim[] => {
  switch (templateRole) {
    case USER_ACCESS_TEMPLATE_ROLES.admin:
      return getAdminTemplateClaims(capabilities);
    case USER_ACCESS_TEMPLATE_ROLES.campaignManager:
      return CAMPAIGN_MANAGER_TEMPLATE_CLAIMS;
    default:
      return [];
  }
};
